import { HHStack } from '@hinge-health/react-component-library';
import { OUTCOME_CLASS_LABELS } from '../constants/partner-data-gateway.constant';
import { ProviderSummary } from '../domain/types';
import { OUTCOME_CLASSES } from '../types';
import { formatCount } from '../utils/format.utils';
import { SectionTitle, StatRow } from './stat-row';
import { SurfaceCard } from './surface-card';

export const PROVIDER_KPIS_TEST_ID = 'pdg-provider-kpis';
export const PROVIDER_KPIS_TITLE = 'At a glance';
export const providerKpiTestId = (key: string): string =>
  `pdg-provider-kpi-${key}`;

const NO_LATEST_FILE = 'None';

interface ProviderKpisProps {
  summary: ProviderSummary;
  configurationsCount: number;
}

/** The numbers behind the chart: what was sampled and how it went. */
export const ProviderKpis = ({
  summary,
  configurationsCount,
}: ProviderKpisProps): JSX.Element => (
  <SurfaceCard paddingX={5} paddingY={4} data-testid={PROVIDER_KPIS_TEST_ID}>
    <HHStack gap={1}>
      <SectionTitle>{PROVIDER_KPIS_TITLE}</SectionTitle>
      <HHStack>
        <StatRow
          label="Latest file"
          value={summary.latestIngestion?.fileName ?? NO_LATEST_FILE}
          testId={providerKpiTestId('latest')}
        />
        <StatRow
          label="Files in sample"
          value={formatCount(summary.recentOutcomes.length)}
          testId={providerKpiTestId('files')}
        />
        {OUTCOME_CLASSES.map(outcomeClass => (
          <StatRow
            key={outcomeClass}
            label={OUTCOME_CLASS_LABELS[outcomeClass]}
            value={formatCount(summary.recentCounts[outcomeClass])}
            testId={providerKpiTestId(outcomeClass)}
          />
        ))}
        <StatRow
          label="Rows parsed"
          value={formatCount(summary.recentRowsParsed)}
          testId={providerKpiTestId('rows')}
        />
        <StatRow
          label="Configurations"
          value={formatCount(configurationsCount)}
          testId={providerKpiTestId('configurations')}
        />
      </HHStack>
    </HHStack>
  </SurfaceCard>
);
